import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useAffiliate } from '../api/affiliates/useAffiliate';
import { getStoredUTMParams } from '../utils/utm';

/**
 * Returns the affiliate and cobrand boolean to inform if the header should
 * co-brand with the returned affiliate.
 *
 * The utm_source is read from the URL, falling back to the params UTMManager
 * persisted in session storage: a few navigations rebuild the query string and
 * drop the utm params (for example `/schedule-appointment?userId=...`), and the
 * header has to stay co-branded on those screens too.
 */
export const useHeaderAffiliate = () => {
  const [searchParams] = useSearchParams();

  const utmSource = useMemo(
    () => searchParams.get('utm_source') || getStoredUTMParams().utm_source,
    [searchParams]
  );

  const { affiliate } = useAffiliate({ affiliateId: utmSource || undefined });

  return { affiliate, cobrand: !!affiliate?.cobranded_header };
};
